import { Injectable } from '@angular/core';
import { FrameEventBus } from '@farris/devkit';

/**
 * æ¡æ¶äºä»¶æå¡
 * @scope FormModule
 */
@Injectable()
class EventService {

  constructor(private eventBus: FrameEventBus) {
  }

  trigger(eventType: string, eventData?: any, frameIds?: string[]) {
    this.eventBus.trigger(eventType, eventData, frameIds);
  }
}

export { EventService };
